export default __webpack_public_path__ + "static/media/should_you_buy_an_apple_watch-750x490.097f026b.jpeg";